import { useState } from 'react'

import cn from 'clsx'

import { useAppDispatch, useAppSelector } from '@App/hooks'
import { MODAL_TYPES } from '@App/redux/slices/modals/enums'
import { closeModal, setModal } from '@App/redux/slices/modals/ModalSlice'
import { asyncCreateAccount } from '@App/redux/slices/user/UserSlice'
import { CloseIcon } from '@App/static/icons/ArrowIcons'
import { ArrowLeft } from '@App/static/icons/DashboardIcons'
import { Flag } from '@App/static/icons/Flags'
import { CheckIcon } from '@App/static/icons/FooterIcons'
import { ArrowRightIcon } from '@App/static/icons/HomeIcons'

import { Button } from '../../controls/Button'
import { ModalTypes } from '../modalTypes'
import ModalWrapper from '../ModalWrapper'

import s from './styles.module.scss'

export const ChooseAccountCurrencyModal = ({ isOpen, setIsOpen, previousModal }: ModalTypes & {previousModal? :MODAL_TYPES}) => {
  const currencies = useAppSelector((state) => state.config.system_currencies)
  const [isLoading, setIsLoading] = useState(false)
  const [selectedCurrency, setSelectedCurrency] = useState(currencies.at(0)?.code)
  const dispatch = useAppDispatch()
  const handleBack = () => {
    dispatch(closeModal())
    dispatch(setModal({ modalType: previousModal || MODAL_TYPES.SWITCH_ACCOUNT_MODAL }))
  }
  const handleCreateAccount = async () => {
    if (selectedCurrency) {
      setIsLoading(true)

      await dispatch(asyncCreateAccount({ currency: selectedCurrency }))

      setIsLoading(false)
    }
  }

  return (
    <ModalWrapper isOpen={isOpen} setIsOpen={setIsOpen}>
      <div className={s.container}>
        <div className={s.header}>
          <ArrowLeft className={s.backIcon} onClick={handleBack} />
          <CloseIcon className={s.closeIcon} onClick={setIsOpen} />
        </div>
        <div className={s.content}>
          <div className={s.title}>Choose account currency</div>
          <div className={s.currencyListContainer}>
            <span className={s.topShadow} />
            <ul className={s.currencyList}>
              {currencies.map((currency) => (
                <li key={currency.code} className={s.currency} onClick={() => setSelectedCurrency(currency.code)}>
                  <Flag code={currency.code} className={s.flag} />
                  <div className={s.right}>
                    <span className={s.name}>
                      {currency.title} <span className={s.code}>{currency.code}</span>
                    </span>
                    <span className={cn(s.check, currency.code === selectedCurrency && s.active)}>
                      {currency.code === selectedCurrency && <CheckIcon className={s.checkIcon} />}
                    </span>
                  </div>
                </li>
              ))}
            </ul>
            <span className={s.bottomShadow} />
          </div>

          <Button className={cn(s.btn, s.outlined, s.small)} isLoading={isLoading} onClick={handleCreateAccount}>
            Create account
          </Button>
        </div>
      </div>
    </ModalWrapper>
  )
}
